import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonNewModule } from '../../common/button-new/button-new.module';
import { SegmentedControlModule } from '../../common/segmented-control/segmented-control.module';
import { TimeZonePickerModule } from '../time-zone-picker/time-zone-picker.module';
import { ButtonModule } from './../../common/button/button.module';
import { GroupModule } from './../../common/group/group.module';
import { IconModule } from './../../common/icon/icon.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { DatePickerModule } from './../../forms/date-picker/date-picker.module';
import { InputModule } from './../../forms/input/input.module';
import { TimePickerDropdownModule } from './../../forms/time-picker/time-picker-dropdown/time-picker-dropdown.module';
import { TimePickerComponent } from './time-picker.component';

@NgModule({
  declarations: [TimePickerComponent],
  exports: [TimePickerComponent],
  imports: [
    GroupModule,
    ButtonModule,
    ButtonNewModule,
    IconModule,
    I18nModule,
    CommonModule,
    DatePickerModule,
    InputModule,
    RtUICoreOverlayModule,
    TimePickerDropdownModule,
    TimeZonePickerModule,
    SegmentedControlModule,
  ],
})
export class TimePickerModule {}
export { TimePickerComponent };
